/**
 * Created by mac on 2/25/20
 */

const TileGame = function (level, options) {
    GameBase.call(this, level, options);

    this.setupMissions();

    this.generator = new TileGenerator();

    this.pagination = new cleverapps.Pagination(this.level.content.screens.length, this.savedGame.page);

    const TableClassName = cleverapps.environment.isEditorScene() ? EditorCardTable : TileTable;
    this.table = new TableClassName();

    this.log = new MovesLog(this, this.savedGame.log);
    this.open = new OpenCards(this.level, this.savedGame.open, this.savedGame.extraSlotUsed);

    this.shownTutorials = this.savedGame.shownTutorials || [];

    const page = this.savedGame.page || 0;
    this.setPage(page, this.savedGame);
    this.pagination.on("changePage", this.setPage.bind(this));

    this.collectedTiles = 0;

    this.on("beforeStartActions", () => {
        this.beginCards = this.countOfCardsToPlay();
    }, this);

    this.counter.registerStage(4, this.danceMove.bind(this));
    this.counter.registerStage(5, this.flip.bind(this));
    this.counter.registerStage(10, this.autoPlayOneCard.bind(this));
    this.counter.registerStage(20, this.changeScreen.bind(this));
    this.counter.registerStage(40, this.checkWin.bind(this));
    this.counter.registerStage(50, this.afterPlayer.bind(this));
    this.counter.registerStage(60, this.activateBoosters.bind(this));

    cleverapps.userStatus.on("active", this.removeHint.bind(this), this);
    cleverapps.userStatus.on("inactive_very_short", this.showHint.bind(this), this);
};

TileGame.prototype = Object.create(GameBase.prototype);
TileGame.constructor = TileGame;

TileGame.prototype.setupMissions = function () {
    if (!this.level.isRegular() || this.hasDanger() || this.level.isBonus()) {
        return;
    }

    const lightingRushMission = cleverapps.missionManager.findByType(Mission.TYPE_LIGHTNING_RUSH);
    if (lightingRushMission && lightingRushMission.isRunning() && lightingRushMission.logic.isActiveState()) {
        this.lightingRushMission = lightingRushMission;
    }
};

TileGame.prototype.setPage = function (page, save) {
    const screen = this.level.content.screens[page];
    let levelCards = screen.cards;

    if (!screen.cards || screen.horizontalCards && cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL && !cleverapps.environment.isEditorScene()) {
        levelCards = screen.horizontalCards;
    }
    const tiles = save && save.table && save.table.cards || levelCards;
    const magic = save && save.table && save.table.magic || TileTable.ListMagicCards(screen);
    const saveRect = save && save.table && save.table.rect;

    this.table.setCards(tiles, magic, screen.maxValue);
    this.table.setRect(saveRect);
    this.table.onResize();

    this.updateClovers();

    if (page !== 0 && (save && !save.page || !save)) {
        this.table.showCards(() => {}, true);
        this.table.flipNormalize();
    }
};

TileGame.prototype.getInfo = function () {
    const info = GameBase.prototype.getInfo.call(this);
    if (!this.stopped) {
        info.table = this.table.getInfo();
        info.log = this.log.getInfo();
        info.shownTutorials = this.shownTutorials;
    }
    return info;
};

TileGame.prototype.storeSave = function () {

};

TileGame.prototype.afterPlayer = function () {
    if (this.move !== undefined) {
        if (!this.stopped) {
            cleverapps.userStatus.reportUserAction();
        }
        this.move = false;
    }
};

TileGame.prototype.flip = function (f, silent) {
    this.table.flipNormalize(f, silent);
};

TileGame.prototype.autoPlayOneCard = function () {
    if (cleverapps.environment.isSceneWithPreview() || this.introPlaying) {
        return;
    }

    const openCards = this.table.cards.filter((card) => card.isOpen());

    for (let i = 0; i < openCards.length; i++) {
        const card = openCards[i];
        card.autoPlay();

        if (this.counter.isActive()) {
            break;
        }
    }
};

TileGame.prototype.danceMove = function () {
    if (!this.move) {
        return;
    }
    this.table.cards.filter((card) => card.isOpen() && !card.inAnimation()).forEach((card) => {
        card.danceMove();
    });
};

TileGame.prototype.changeScreen = function () {
    if (this.table.isEmpty() && this.outcome === GameBase.OUTCOME_UNKNOWN && !this.open.counter.isActive() && !cleverapps.environment.isEditorScene()) {
        this.pagination.nextPage();
    }
};

TileGame.prototype.isWin = function () {
    return this.table.isEmpty() && !this.open.counter.isActive() && this.pagination.isLast();
};

TileGame.prototype.checkWin = function () {
    if (this.isWin()) {
        this.win();
    }
};

TileGame.prototype.getDailyCupStars = function () {
    return this.beginCards;
};

TileGame.prototype.playCard = function (card) {
    this.move = Card.MOVES.PLAY;
    if (card.feature !== "wild") {
        this.table.updateFeatures(this.move);
    }

    if (cleverapps.dailyTasks) {
        cleverapps.dailyTasks.processOpenCard(card);
    }

    this.open.acceptCard(card);
    if (!card.feature) {
        this.log.push(MovesLog.MOVE_PLAY_CARD, { value: card.value });
    } else {
        this.log.clear();
    }

    this.collectedTiles++;
    this.score.addPoints(10);

    this.counter.trigger();
};

TileGame.prototype.undoCard = function (card) {
    this.table.addCard(card, card.index);
    this.move = Card.MOVES.UNDO;
    this.table.updateFeatures(this.move);
    this.table.returnCard(card);
};

TileGame.prototype.removeHint = function () {
    this.hideHint();
};

TileGame.prototype.hideHint = function () {
    if (this.hintCard) {
        this.hintCard.trigger("hideTutorial");
        this.hintCard = undefined;
    }
};

TileGame.prototype.showHint = function () {
    if (!this.canShowHint()) {
        this.hideHint();
        return;
    }

    const card = this.getCardForHint();

    if (this.hintCard !== card) {
        this.hideHint();
    }

    if (card && !card.inAnimation()) {
        this.hintCard = card;
        this.hintCard.trigger("showTutorial");
    }
};

TileGame.prototype.canShowHint = function () {
    return !(this.outcome !== GameBase.OUTCOME_UNKNOWN || cleverapps.focusManager.isFocused() || this.counter.isActive()
        || cleverapps.config.editorMode || cleverapps.environment.isSceneWithPreview() || cleverapps.forces.isRunningForce());
};

TileGame.prototype.activateBoosters = function () {
    if (this.outcome === GameBase.OUTCOME_UNKNOWN && !cleverapps.environment.isSceneWithPreview()) {
        if (this.log.isUndoNeedOnPreviousMove()) {
            this.log.showAlert();
        }
    }
};

TileGame.prototype.getCardForHint = function (conditions) {
    const cards = this.table.listMissed();

    if (conditions) {
        return cards.find((card) => card.isAppropriate(conditions));
    }

    const tableCardsStore = {};
    const openCardsStore = {};

    cards.forEach((card) => {
        tableCardsStore[card.value] = tableCardsStore[card.value] || 0;
        tableCardsStore[card.value]++;
    });

    this.open.cards.forEach((card) => {
        openCardsStore[card.value] = openCardsStore[card.value] || 0;
        openCardsStore[card.value]++;
    });

    const cadValues = Object.keys(tableCardsStore).sort((a, b) => {
        const openB = openCardsStore[b] || 0;
        const openA = openCardsStore[a] || 0;
        const tableB = Math.min(tableCardsStore[b], 3);
        const tableA = Math.min(tableCardsStore[a], 3);

        const dif = (tableB + openB) - (tableA + openA);
        return dif || openB - openA;
    });

    return cards.find((card) => card.value === Number(cadValues[0]));
};

TileGame.prototype.stop = function (...args) {
    GameBase.prototype.stop.apply(this, args);

    this.generator.clear();
    this.log.clear();
    this.open.clear();

    this.removeHint();
};

TileGame.prototype.countOfCardsToPlay = function () {
    let amount = this.table.cards.length;
    for (let i = this.pagination.getCurrent() + 1; i < this.pagination.getTotal(); i++) {
        const screen = this.level.content.screens[i];
        const cards = screen.cards || screen.horizontalCards;

        amount += cards.length + TileTable.ListMagicCards(screen).length;
    }

    return amount;
};

TileGame.prototype.getPercentOfCompletion = function () {
    return 1 - this.countOfCardsToPlay() / this.beginCards;
};

TileGame.prototype.updateClovers = function () {

};
